import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, share } from 'rxjs';

import { environment } from '@kr/environment';
import { Transaction, Transfer } from '@kr/models';
import { OrganizationService } from '@kr/services';

import { TransferApi } from './transfer-api.interface';
import { PayOutRes } from '../models/pay-out.response';

@Injectable({ providedIn: 'root' })
export class TransferApiService implements TransferApi {
  readonly #http = inject(HttpClient);
  readonly #organizationService = inject(OrganizationService);
  readonly #apiHost = environment.apiHost;

  readonly #estimatesTransferInternal = `${this.#apiHost}/transactions/payout/internal/estimates/`;
  readonly #estimatesTransferExternal = `${this.#apiHost}/transactions/payout/single/estimates/`;

  readonly #executeTransferInternal = `${this.#apiHost}/transactions/payout/internal/`;
  readonly #executeTransferExternal = `${this.#apiHost}/transactions/payout/single/`;

  getEstimatesTransferInternal(body: Transfer, orgId: number): Observable<Transaction> {
    return this.#http
      .post<Transaction>(this.#estimatesTransferInternal, body, {
        headers: this.#organizationService.getHttpHeaders(orgId),
      })
      .pipe(share());
  }

  getEstimatesTransferExternal(body: Transfer, orgId: number): Observable<Transaction> {
    return this.#http
      .post<Transaction>(this.#estimatesTransferExternal, body, {
        headers: this.#organizationService.getHttpHeaders(orgId),
      })
      .pipe(share());
  }

  executeTransferInternal(body: Transfer, orgId: number): Observable<PayOutRes> {
    return this.#http
      .post<PayOutRes>(this.#executeTransferInternal, body, {
        headers: this.#organizationService.getHttpHeaders(orgId),
      })
      .pipe(share());
  }

  executeTransferExternal(body: Transfer, orgId: number): Observable<PayOutRes> {
    return this.#http
      .post<PayOutRes>(this.#executeTransferExternal, body, {
        headers: this.#organizationService.getHttpHeaders(orgId),
      })
      .pipe(share());
  }
}
